import React from "react";
import * as styles from "./styles.module.scss";
import cn from "classnames";

const InfoModal = ({ infoText, active, closeModal }) => {
  return (
    <div
      className={cn(styles.modalBackground, {
        [styles.active]: active
      })}
    >
      <div
        className={cn(styles.modal, {
          [styles.active]: active
        })}
      >
        <div className={styles.buttonContainer}>
          <button onClick={closeModal} className={styles.closeButton}>
            <div className={styles.closeButtonIcon}>
              <XSVG />
            </div>
          </button>
        </div>

        <div className={styles.text}>
          <p>{infoText}</p>
        </div>
      </div>
    </div>
  );
};

export default InfoModal;

const XSVG = () => (
  <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.52827 0.528636C0.788619 0.268287 1.21073 0.268287 1.47108 0.528636L4.99967 4.05723L8.52827 0.528636C8.78862 0.268287 9.21073 0.268287 9.47108 0.528636C9.73143 0.788986 9.73143 1.2111 9.47108 1.47145L5.94248 5.00004L9.47108 8.52864C9.73143 8.78899 9.73143 9.2111 9.47108 9.47145C9.21073 9.7318 8.78862 9.7318 8.52827 9.47145L4.99967 5.94285L1.47108 9.47145C1.21073 9.7318 0.788619 9.7318 0.52827 9.47145C0.26792 9.2111 0.26792 8.78899 0.52827 8.52864L4.05687 5.00004L0.52827 1.47145C0.26792 1.2111 0.26792 0.788986 0.52827 0.528636Z"
      fill="currentColor"
    />
  </svg>
);
